import React from 'react';
import RadioSection from '../RadioSection';
import TextBox from '../../Basic/TextBox';
import PhoneBox from '../../Enhanced/PhoneBox';
const WorkSiteContact = (p) => {
    const lookup = window.osa.lookup.projectSpecifics;
    return (
        <div>
            <RadioSection name="workSiteContact" {...lookup.workSiteContact} inline />
            {p.isDifferentContactSelected ?
                <div>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-4">
                                <TextBox title={lookup.workSiteContactName} name="workSiteContactName" required />
                            </div>
                            <div className="col-sm-4">
                                <PhoneBox id="workSiteContactPhone" name="workSiteContactPhone" title={lookup.workSiteContactPhone} ext="1" required />
                            </div>
                            <div className="col-sm-4">
                                <PhoneBox id="workSiteCellPhone" name="workSiteCellPhone" title={lookup.workSiteCellPhone} />
                            </div>
                            <div className="col-sm-4">
                                <TextBox id="workSitePosition" name="workSiteContactPoistion" title={lookup.workSiteContactPoistion} />
                            </div>
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
    );
};
export default WorkSiteContact;